var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"emphasis"},[_c('h2',[_vm._v("Page Not found "),_c('span',{staticClass:"big-emoji"},[_vm._v(" 🧐")])]),_c('div',{staticClass:"left"},[_c('p',[_vm._v(" I was not able to find the page you were looking for. ")]),_c('p',{staticClass:"desc"},[_vm._v(" There is no such page found on this site. ")])])])
}]

export { render, staticRenderFns }